{
  "volume": "Volume (LCM)",
  "comment": "Comment",
  "add": "Add Dewatering",
  "editTitle": "Edit Dewatering",
  "added": "Added",
  "saved": "Saved",
  "deleted": "Deleted",
  "validation": {
    "dateRequired": "Date is required",
    "locationRequired": "Location is required",
    "volumePositive": "Volume must be > 0"
  }
}
